
        var result = require("!!../../../../node_modules/css-loader/index.js!./treatment-salesgroup.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-base/treatment-salesgroup.component.css
// module id = 2391
// module chunks = 1